import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { cloneExpense } from 'redux/booking/travel/setting/expenseSlice';
import { Confirmation } from 'components/common';

const CloneExpenseConfirm = ({ showModal, setshowModal, record }) => {
  const dispatch = useDispatch();

  const closeModal = () => setshowModal(false);

  const handleConfirm = async () => {
    try {
      const response = await dispatch(cloneExpense(record.id));
      if (response.payload?.data?.id) closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Confirmation
      show={showModal}
      type="warning"
      title="Clone new expense"
      message={`Are you sure to clone a new expense from current ${record?.name}-ID#${record?.id}?`}
      confirmText="Clone"
      cancelText="Cancel"
      onConfirm={handleConfirm}
      onCancel={closeModal}
    />
  );
};

CloneExpenseConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
};

export default CloneExpenseConfirm;
